import { render } from "./ExtendPlanAndAttachTrial.vue?vue&type=template&id=3df2675f"
import script from "./ExtendPlanAndAttachTrial.vue?vue&type=script&lang=js"
export * from "./ExtendPlanAndAttachTrial.vue?vue&type=script&lang=js"

import "./ExtendPlanAndAttachTrial.vue?vue&type=style&index=0&id=3df2675f&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__